/**
 * DOS518 - Digital Operations System for Wildfire Management
 * 
 * Copyright (c) 2024-2025 Angelo Irtilaç
 * All rights reserved.
 * 
 * This software is proprietary and confidential.
 * Unauthorized copying, distribution, modification, or use is strictly prohibited.
 * 
 * ---
 * 
 * Author: Angelo Irtilaç
 * Qualifications: DOS (Direttore delle Operazioni di Spegnimento)
 *                39 years - Corpo Nazionale dei Vigili del Fuoco
 *                DOS Trainer & Instructor
 * 
 * Location: Carpi, Italy
 * Contact: [inserire email]
 * 
 * ---
 * 
 * This software implements official Italian Fire Department protocols:
 * - C.O.A.U. (Centro Operativo Aereo Unificato)
 * - SI.TA.C. (Sistema Tattico di Coordinamento)
 * - L.A.C.E.S. (Lookout, Awareness, Communication, Escape routes, Safety zones)
 * 
 * Developed with operational expertise acquired through decades of wildfire
 * emergency management and coordination of suppression operations.
 * 
 * For commercial licensing inquiries, please contact the author.
 */
// ============================================
// CollapsibleSection - Component Riutilizzabile
// Per sezioni COAU che si aprono/chiudono
// ============================================

import React from 'react';
import './CollapsibleSection.css';

interface CollapsibleSectionProps {
  id: string;
  title: string;
  emoji: string;
  isOpen: boolean;
  onToggle: () => void;
  children: React.ReactNode;
  defaultOpen?: boolean;
}

export const CollapsibleSection: React.FC<CollapsibleSectionProps> = ({
  id,
  title,
  emoji,
  isOpen,
  onToggle,
  children,
}) => {
  return (
    <div className="collapsible-section" data-section={id}>
      <button
        type="button"
        className={`section-header ${isOpen ? 'open' : 'closed'}`}
        onClick={onToggle}
        aria-expanded={isOpen}
        aria-controls={`section-content-${id}`}
      >
        <span className="section-title">
          <span className="section-emoji">{emoji}</span>
          <span className="section-text">{title}</span>
        </span>
        <span className="section-toggle">
          {isOpen ? '▼' : '▶'}
        </span>
      </button>

      {isOpen && (
        <div
          id={`section-content-${id}`}
          className="section-content"
          role="region"
          aria-labelledby={`section-header-${id}`}
        >
          {children}
        </div>
      )}
    </div>
  );
};

export default CollapsibleSection;
